module.exports = __webpack_public_path__ + "static/media/news-aptihealth-saratoga-living.0d158a64.jpg";